import { useEffect } from 'react';

import { Copy01Icon } from '@hugeicons/core-free-icons';
import patternValidators from 'helpers/validators/pattern-validators';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, Input, InputGroup } from 'components/FormComponents';

export const DuplicateBrandModal = ({
  brand,
  visible,
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (brand) {
      reset({
        name: brand.name + ' (Copy)',
        brand_name: brand.brand_name || '',
        brand_email: brand.brand_email || '',
      });
    } else {
      reset();
    }
  }, [brand, reset]);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={t('branding.duplicateModal.title')}
      description={t('branding.duplicateModal.description')}
      icon={Copy01Icon}
      oldIconLibrary={false}
      small>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <InputGroup
          title={t('branding.createModal.brandName')}
          description="Internal name used to identify this brand in the dashboard.">
          <Input
            name="name"
            placeholder="e.g. Internal employee"
            register={register}
            validators={{ required: true }}
            error={errors?.name?.type}
          />
        </InputGroup>

        <InputGroup
          title="Display Name"
          description="Public-facing name shown to candidates and external users.">
          <Input
            name="brand_name"
            placeholder="e.g. Checkmate tech"
            register={register}
            validators={{ required: true }}
            error={errors?.brand_name?.type}
          />
        </InputGroup>

        <InputGroup title={t('branding.createModal.brandEmail')} optional>
          <Input
            name="brand_email"
            placeholder="e.g. noreply@acme.com"
            register={register}
            validators={patternValidators.email}
            error={errors?.brand_email?.message}
          />
        </InputGroup>

        <div className="flex justify-end gap-2 mt-2">
          <Button type="secondary" onClick={onClose}>
            {t('branding.createModal.close')}
          </Button>
          <Button submit disabled={isSubmitting}>
            {isSubmitting
              ? t('branding.duplicateModal.duplicating')
              : t('branding.duplicateModal.duplicate')}
          </Button>
        </div>
      </form>
    </AnimatedModal>
  );
};
